(function(){
  function initBwhCarousel(){
    const containers = document.querySelectorAll('.article__content-inner');
    if (!containers.length) return;

    const shortcodeRegex = /\[collection-carousel="([^"]+)"([^\]]*)\]/g;

    containers.forEach(container => {
      let idx = 0;
      container.innerHTML = container.innerHTML.replace(
        shortcodeRegex,
        (_, handle, rawParams) => {
          const params = parseParams(rawParams);
          const id = `bwh-carousel-${handle}-${idx++}`;
          let div = `<div id="${id}" class="bwh-slider-wrapper bwh-slider-carousel" data-handle="${handle}"`;

          if (params.tag)               div += ` data-tag="${escAttr(params.tag)}"`;
          if (params.tags)              div += ` data-tags="${escAttr(params.tags)}"`;
          if (params.handles)           div += ` data-handles="${escAttr(params.handles)}"`;
          if (params['exclude-handles']) div += ` data-exclude-handles="${escAttr(params['exclude-handles'])}"`;
          if (params['group-by'])       div += ` data-group-by="${escAttr(params['group-by'])}"`;
          if (params['prefer-handle'])  div += ` data-prefer-handle="${escAttr(params['prefer-handle'])}"`;
          if (params.limit)             div += ` data-limit="${escAttr(params.limit)}"`;

          div += `>
              <div class="swiper swiper-container">
                <div class="swiper-wrapper"></div>
                <div class="swiper-pagination"></div>
              </div>
            </div>
          `;
          return div;
        }
      );
    });

    document.querySelectorAll('.bwh-slider-wrapper').forEach(wrapper => {
      const handle   = wrapper.dataset.handle;
      const swiperEl = wrapper.querySelector('.swiper-container');
      const trackEl  = wrapper.querySelector('.swiper-wrapper');

      fetch(`/collections/${handle}/products.json`)
        .then(r => r.json())
        .then(data => {
          let products = data.products || [];

          const tagFilter = wrapper.dataset.tag;
          if (tagFilter) {
            const tf = tagFilter.toLowerCase();
            products = products.filter(p =>
              p.tags.some(t => t.toLowerCase() === tf)
            );
          }

          const tagsFilter = wrapper.dataset.tags;
          if (tagsFilter) {
            const tagList = tagsFilter.toLowerCase().split(',').map(s => s.trim());
            products = products.filter(p =>
              p.tags.some(t => tagList.indexOf(t.toLowerCase()) !== -1)
            );
          }

          const handlesFilter = wrapper.dataset.handles;
          if (handlesFilter) {
            const handleList = handlesFilter.toLowerCase().split(',').map(s => s.trim());
            products = products.filter(p => {
              const h = p.handle.toLowerCase();
              return handleList.some(sub => h.indexOf(sub) !== -1);
            });
          }

          const excludeHandles = wrapper.dataset.excludeHandles;
          if (excludeHandles) {
            const excludeList = excludeHandles.toLowerCase().split(',').map(s => s.trim());
            products = products.filter(p => {
              const h = p.handle.toLowerCase();
              return !excludeList.some(sub => h.indexOf(sub) !== -1);
            });
          }

          const groupBy = wrapper.dataset.groupBy;
          if (groupBy === 'model') {
            const preferHandle = wrapper.dataset.preferHandle;
            const preferList = preferHandle
              ? preferHandle.toLowerCase().split(',').map(s => s.trim())
              : [];

            const buckets = {};
            const bucketOrder = [];
            products.forEach(p => {
              const key = getModelKey(p.handle);
              if (!buckets[key]) {
                buckets[key] = [];
                bucketOrder.push(key);
              }
              buckets[key].push(p);
            });

            products = bucketOrder.map(key => {
              const group = buckets[key];
              if (group.length === 1 || preferList.length === 0) return group[0];

              for (let i = 0; i < preferList.length; i++) {
                for (let j = 0; j < group.length; j++) {
                  if (group[j].handle.toLowerCase().indexOf(preferList[i]) !== -1) {
                    return group[j];
                  }
                }
              }
              return group[0];
            });
          }

          const limitVal = parseInt(wrapper.dataset.limit, 10);
          if (limitVal && limitVal > 0) {
            products = products.slice(0, limitVal);
          }

          products.forEach(prod => {
            const imgSrc = prod.images?.[0]?.src
                         || prod.images?.[0]?.src
                         || '';

            const price = prod.variants?.[0]?.price || '0.00';
            const slide = document.createElement('div');
            slide.className = 'swiper-slide article--product-card';

            slide.innerHTML = `
              <div class="product-image">
                ${imgSrc ? `<a href="/products/${prod.handle}"><img src="${imgSrc}" alt="${escAttr(prod.title)}" loading="lazy"></a>` : ''}
              </div>
              <div class="product-info">
                <div class="product-name"><a href="/products/${prod.handle}">${prod.title}</a></div>
                <div class="product-prices">$${price}</div>
                <div class="product-atc"><a href="/products/${prod.handle}" class="purchase-btn">Buy Now</a></div>
              </div>
            `;
            trackEl.appendChild(slide);
          });

          new Swiper(swiperEl, {
            slidesPerView: 'auto',
            spaceBetween: 0,
            loop: true,
            pagination: {
              el: ".swiper-pagination",
              clickable: true,
            }
          });
        });
    });
  }

  function parseParams(raw) {
    const params = {};
    if (!raw) return params;
    const regex = /(\w[\w-]*)="([^"]*)"/g;
    let match;
    while ((match = regex.exec(raw)) !== null) {
      params[match[1]] = match[2];
    }
    return params;
  }

  function getModelKey(handle) {
    const parts = handle.split('-');

    let start = 0;
    let leadingSize = '';
    while (start < parts.length && /^\d+$/.test(parts[start])) {
      if (!leadingSize) leadingSize = parts[start];
      start++;
    }

    if (parts[start] === 'inches') start++;

    if (parts[start] === 'better' && parts[start + 1] === 'wood') {
      return 'better-wood';
    }

    const modelName = parts[start] || parts[0];

    if (leadingSize && modelName !== 'midcentury') {
      return modelName + '-' + leadingSize;
    }

    const sizeMatch = handle.match(/(\d{2,3})-inch/);
    if (sizeMatch) {
      return modelName + '-' + sizeMatch[1];
    }

    return modelName;
  }

  function escAttr(str) {
    return str.replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  document.addEventListener('DOMContentLoaded', initBwhCarousel);
})();